import styled from "styled-components";

export const DataSources = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    overflow: visible;
`;

export const Tooltip = styled.div`
    position: absolute;

    left: 100%;
    bottom: 100%;
    transform: translateX(-30px);
    width: max-content;
    max-width: 280px;
    padding: 10px;
    background: #333;
    border-radius: 4px;
    color: #fff;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    pointer-events: none;
    z-index: 1000;

    &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 12px;
        border-width: 6px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
    }
`;

export const SourceChip = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 10px;
    background: #f4ecfa;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: default;

    &:hover ${Tooltip} {
        opacity: 1;
        visibility: visible;
    }

    .source-chip-image {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
    }

    span {
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
    }
`;
